// @flow
import xws from 'api/xws/';
import qs from 'query-string';

// Constants
import { getService } from 'constants/ajax';

export default function lostPasswordWS(data: {|
  tokenId: string,
  webkey: string,
  email: string
|}): Promise<any> {
  const loginService = getService('lostPassword');
  return xws(loginService).post(loginService.getPath(), qs.stringify(data));
}



// WEBPACK FOOTER //
// ./src/api/xws/login/lostPasswordWs.js